<template>
  <div>
    <CargandoPaginaWeb v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></CargandoPaginaWeb>
    <CargandoInformacion :props="'cargandoInformacionPaginaWeb_div'"></CargandoInformacion>
    <VisorDeDocumentos></VisorDeDocumentos>
    <!-- <div class="caja-anuncio"><div class="anuncio">
    <i class="fas fa-bell campana"></i>  <a class="parpadea"> Edicto Publicado el 13 de Septiembre de 2022 </a>
  </div></div> -->
    <MenuAnuncio></MenuAnuncio>
    <MenuSuperior v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></MenuSuperior>
    <MenuSuperiorEspecial v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></MenuSuperiorEspecial>
    <MenuResponsivo v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></MenuResponsivo>
    <div id="web-container" style="z-index: 20">
      <transition name="fade" mode="out-in"  >
        <router-view :key="$route.path" v-on:marcaLaCargaYVerifica="MarcaLaCargaYVerifica"></router-view>
      </transition>

    </div>
  



    <!-- Modal -->
    <!--<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">AVISO</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
       <p style="font-size:2em"> Por motivos de contingencia
        el horario de atención al
        público es de 9:00 a 14:00 hrs. hasta nuevo aviso. </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>-->



  </div>
</template>

<script>
  import MenuSuperior from '@/components/PaginaOficial/Comun/MenuSuperior/MenuSuperior.vue';
  import MenuSuperiorEspecial from '@/components/PaginaOficial/Comun/MenuSuperior/MenuSuperiorEspecial.vue';
  import MenuResponsivo from '@/components/PaginaOficial/Comun/MenuResponsivo/MenuResponsivo.vue';
  import MenuInferior from '@/components/PaginaOficial/Comun/MenuInferior.vue';
  import CargandoPaginaWeb from "@/components/PaginaOficial/Comun/CargandoPaginaWeb.vue";
  import CargandoInformacion from '../../Comunes/CargandoInformacion.vue'
  import VisorDeDocumentos from "@/components/PaginaOficial/Comun/VisorDeDocumentos.vue";
  import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";
  import MenuAnuncio from "@/components/PaginaOficial/Comun/MenuSuperior/MenuAnuncios.vue"


  export default {
    name: `Plantilla`,
    components: {
      MenuSuperior,
      MenuResponsivo,
      MenuSuperiorEspecial,
      MenuInferior, 
      CargandoPaginaWeb, 
      CargandoInformacion, 
      VisorDeDocumentos,
      MenuAnuncio
    }, 
    data() {
      return {
        enumeraciones_sicpo,
        cargoMenuSuperior: Number, 
        cargoMenuSuperiorEspecial: Number, 
        cargoMenuResponsivo: Number,
        cargoMenuInferior: Number,
        cargoPaginaOficial: Number
      }
    },
    beforeMount() {
      this.cargoMenuSuperior = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
      this.cargoMenuSuperiorEspecial = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
      this.cargoMenuResponsivo = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
      this.cargoMenuInferior = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;
      this.cargoPaginaOficial = this.enumeraciones_sicpo.EstadosDeCarga.Cargando;

      this.VerificaQueHayaFinalizadoTodaLaCarga();
    },
    methods: {
      MarcaLaCargaYVerifica: function(nombreDeLaVariable, estatus) {
        this[nombreDeLaVariable] = estatus;

        this.VerificaQueHayaFinalizadoTodaLaCarga();
      }, 
      VerificaQueHayaFinalizadoTodaLaCarga: function() {
        // console.log("cargoMenuSuperior", this.cargoMenuSuperior);
        // console.log("cargoMenuSuperiorEspecial", this.cargoMenuSuperiorEspecial);
        // console.log("cargoMenuResponsivo", this.cargoMenuResponsivo);
        // console.log("cargoMenuInferior", this.cargoMenuInferior);
        // console.log("cargoPaginaOficial", this.cargoPaginaOficial);
       
        if(this.cargoMenuSuperior === this.enumeraciones_sicpo.EstadosDeCarga.Error || 
          this.cargoMenuSuperiorEspecial === this.enumeraciones_sicpo.EstadosDeCarga.Error || 
          this.cargoMenuResponsivo === this.enumeraciones_sicpo.EstadosDeCarga.Error || 
          this.cargoMenuInferior === this.enumeraciones_sicpo.EstadosDeCarga.Error || 
          this.cargoPaginaOficial === this.enumeraciones_sicpo.EstadosDeCarga.Error) {
          $("#principalPaginaWeb_div_cargandoInformacion").addClass("d-none");
          $("#principalPaginaWeb_div_paginaWebEnMantenimiento").removeClass("d-none");
        } else if(this.cargoMenuSuperior === this.enumeraciones_sicpo.EstadosDeCarga.Cargado && 
          this.cargoMenuSuperiorEspecial === this.enumeraciones_sicpo.EstadosDeCarga.Cargado && 
          this.cargoMenuResponsivo === this.enumeraciones_sicpo.EstadosDeCarga.Cargado && 
         // this.cargoMenuInferior === this.enumeraciones_sicpo.EstadosDeCarga.Cargado && 
          this.cargoPaginaOficial === this.enumeraciones_sicpo.EstadosDeCarga.Cargado) {
          $("#principalPaginaWeb_div").addClass("cerrarCargaDePaginaWeb");
        } else {
          $("#principalPaginaWeb_div").removeClass("cerrarCargaDePaginaWeb");
          
        }
      }
  
  }
  }
</script>

<style>
  
  #web-container {
    background-color: #FFFFFF;
    min-height: calc(100vh - 143px);
    color: #111;
    overflow-y: auto;
  }

  .cerrarScrollMientrasCarga {
    overflow: hidden;
  }

  .page-text {
    /*white-space: pre;*/
    white-space: pre-wrap;
    text-align: justify;
  }

  .page-title {
    text-align: center;
    font-size: 3em;
    padding: 10px 0 20px;
  }


</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/Comun/Plantilla.vue